const loadingArrayList = {
  default: [0, 1, 2, 3],
  internalNews: [1, 2, 3],
  artistList: [1, 2, 3, 4, 5],
  infiniteList: [1, 2, 3, 4, 5, 6],
  marketList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  loading15: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  loading25: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
};

export default loadingArrayList;
